import script from "./KeyboardShortcutsHelp.vue?vue&type=script&setup=true&lang=js"
export * from "./KeyboardShortcutsHelp.vue?vue&type=script&setup=true&lang=js"

import "./KeyboardShortcutsHelp.vue?vue&type=style&index=0&id=4e4bdcd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e4bdcd1"]])

export default __exports__